module.exports = __webpack_public_path__ + "media/images/video-icon-8cb037b8421b430fddd2f6448f928fcd.svg";